module.exports = __webpack_public_path__ + "images/leek_web-db6828ae6be416fe9a03747f9015ea1c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/leek_web.svg
// module id = 214
// module chunks = 0